import React from 'react';
import PropTypes from 'prop-types';
import { FDStack } from '@facet-wealth/design';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import ErrorList from 'Components/UI/ErrorList';
import { LottieLoadingLayout } from 'Organisms/LottieControl/LottieLoadingLayout';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  TransferLottieVertical,
} from 'Views/Page/Content/Templates/CapitalizeRolloverAccountsStatusStepTemplate/Content/TransferLottieVertical';

const Layout = ({ errors }) => {
  const { resource } = useMetaLayoutContext();


  return (
    <FDStack direction="column" spacing={4} paddingY={4} justifyContent={'center'} alignItems={'center'}>
      <FDStack direction="column" justifyContent={'center'} alignItems={'center'} spacing={2} maxWidth={'80%'}>
        <MetaField attr="title" />
        <LottieLoadingLayout>
          <TransferLottieVertical resource={resource} />
        </LottieLoadingLayout>
        <FDStack direction={'row'} justifyContent={'center'} spacing={2} width={'100%'} maxWidth={'295px'}>
          <MetaField attr="destinationAccountName" />
          <MetaField attr="secondaryDestinationAccountName" />
        </FDStack>
        <MetaField attr="subtitle" />
      </FDStack>
      <ErrorList title={'Errors occurred while submitting'} errors={errors} />
    </FDStack>
  );
};

Layout.defaultProps = {
  errors: [],
};

Layout.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.object),
};

export default Layout;
